import { render, staticRenderFns } from "./program-methodology.vue?vue&type=template&id=7c217ff6&"
import script from "./program-methodology.vue?vue&type=script&lang=ts&"
export * from "./program-methodology.vue?vue&type=script&lang=ts&"
import style0 from "./program-methodology.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports